import { render, staticRenderFns } from "./Fixedassets.vue?vue&type=template&id=3d5b2b6a&scoped=true&"
import script from "./Fixedassets.vue?vue&type=script&lang=js&"
export * from "./Fixedassets.vue?vue&type=script&lang=js&"
import style0 from "./Fixedassets.vue?vue&type=style&index=0&id=3d5b2b6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5b2b6a",
  null
  
)

export default component.exports